import Glide from '@glidejs/glide';

const options = {
	perView: 3,
	rewind: false,
	bound: true,
	gap: 30,
	breakpoints: {
		768: {
			perView: 1
		}
	}
};

if(document.querySelector('.glide')) {
	new Glide('.glide', options).mount();
}